var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVotingIcon1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\xD0\xA0\xD0\x8E\xD0\xA0\xC2\xBB\xD0\xA0\xD1\x95\xD0\xA0\xE2\x84\x96_1",
    clipPath: "url(#clip0_3_94219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30 0H4C1.79086 0 0 1.79086 0 4V30C0 32.2091 1.79086 34 4 34H30C32.2091 34 34 32.2091 34 30V4C34 1.79086 32.2091 0 30 0Z",
    fill: "#E8F7F5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.99 10.8599V8.20989L23.7 6.88989L21.41 8.20989V10.8599L23.7 12.1799L25.99 10.8599Z",
    stroke: "#09363F",
    strokeWidth: 1.36,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.99 24.4599C25.99 25.2799 25.55 26.0399 24.84 26.4499C24.13 26.8599 23.26 26.8599 22.55 26.4499C21.84 26.0399 21.4 25.2799 21.4 24.4599C21.4 23.6399 21.84 22.8799 22.55 22.4699C23.26 22.0599 24.13 22.0599 24.84 22.4699C25.55 22.8799 25.99 23.6399 25.99 24.4599Z",
    stroke: "#09363F",
    strokeWidth: 1.36,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.95001 23.1398V25.7898L10.24 27.1098L12.54 25.7898V23.1398L10.24 21.8198L7.95001 23.1398Z",
    stroke: "#09363F",
    strokeWidth: 1.36,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.95001 9.53993C7.95001 8.71993 8.39001 7.95993 9.10001 7.54993C9.81001 7.13993 10.68 7.13993 11.39 7.54993C12.1 7.95993 12.54 8.71993 12.54 9.53993C12.54 10.3599 12.1 11.1199 11.39 11.5299C10.68 11.9399 9.81001 11.9399 9.10001 11.5299C8.39001 11.1199 7.95001 10.3599 7.95001 9.53993Z",
    stroke: "#09363F",
    strokeWidth: 1.36,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M22.13 11.2798L11.81 22.7198",
    stroke: "#09363F",
    strokeWidth: 1.36,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M12.54 9.53979H18.91",
    stroke: "#09363F",
    strokeWidth: 1.36,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M15.03 24.46H21.41",
    stroke: "#09363F",
    strokeWidth: 1.36,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M11.78 11.24L15.2 15.01",
    stroke: "#09363F",
    strokeWidth: 1.36,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M18.77 18.9399L22.2 22.7099",
    stroke: "#09363F",
    strokeWidth: 1.36,
    strokeLinejoin: "bevel"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_94219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVotingIcon1);
export default __webpack_public_path__ + "static/media/voting_icon1.9d18f9c451f24c066205eebe938e5d87.svg";
export { ForwardRef as ReactComponent };